import SubjectBlock from "./SubjectBlock";
import {useState} from "react";

const Means = ({means, minEsts, index}) => {
    const [sortMethod, setSortMethod] = useState(["subj", 1]);
    return (
        <div className="means">
            <div className="sortButtons">
                <span className="left" onClick={() => setSortMethod(prev => prev[0] === "mean" ? [prev[0], -prev[1]] : ["mean", 1])}>Балл</span>
                <span className="center"><span style={{cursor: "pointer"}} onClick={() => setSortMethod(prev => prev[0] === "subj" ? [prev[0], -prev[1]] : ["subj", 1])}>Предмет</span></span>
                <span className="right" onClick={() => setSortMethod(prev => prev[0] === "num" ? [prev[0], -prev[1]] : ["num", 1])}>Количество</span>
            </div>
            <div className="infos">
                {means.sort((a,b) => sortMethod[0] === "subj" ? (a.subj.localeCompare(b.subj)*sortMethod[1]) : (a[sortMethod[0]]-b[sortMethod[0]])*sortMethod[1]).map(m => <SubjectBlock key={m.subj} {...m} minEsts={minEsts} index={index} />)}
            </div>
        </div>
    );
}

export default Means;